import { render, staticRenderFns } from "./BudgetCenters.vue?vue&type=template&id=52df0f16"
import script from "./BudgetCenters.vue?vue&type=script&lang=js"
export * from "./BudgetCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports